module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp2_9006.dfee9254.png";